import { Accordion, styled } from "@mui/material";

export const ReservationAccordion = styled(Accordion)<{ disabled: boolean }>(({ theme, disabled }) => ({
	width: "100%",
	border: `1px solid ${disabled ? theme.palette.grey[300] : theme.palette.primary.main}`,
	borderRadius: "10px",
	borderTopRightRadius: "10px !important",
	borderTopLeftRadius: "10px !important",
	borderBottomRightRadius: "10px !important",
	borderBottomLeftRadius: "10px !important",
	backgroundColor: "transparent",
	marginBottom: "16px",
}));
